module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "monitor-container"
  }, [_c('el-card', {
    staticClass: "monitor-card1"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('CGM')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('timeOfLaRead')) + " :"), _c('span', [_vm._v(" " + _vm._s(_vm.sensorTime))])])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('table', {
    staticClass: "status-table1"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('tranSn')) + ":  "), _c('label', [_vm._v(_vm._s(_vm.sensor.serial))])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('status')) + ":"), _c('label', [_vm._v(_vm._s(_vm.sensor.status))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('sensorLife')) + ":"), _c('label', [_vm._v(_vm._s(_vm.sensor.sensorLifetimeTotalCount))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('lastSenorRead')) + ": "), _c('label', [_vm._v(_vm._s(_vm.getGlucose))]), _vm._v(" "), _c('img', {
    staticClass: "sgIcon",
    attrs: {
      "src": _vm.sgIcon,
      "id": "sgIcon"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.updateTime1))])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('TranBattery')) + ":\n            "), (_vm.showCGMStatus) ? _c('img', {
    attrs: {
      "src": _vm.batteryIcon
    }
  }) : _c('label', [_vm._v("--")])])])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "graph",
    attrs: {
      "id": "chart1",
      "element-loading-text": _vm.loadingText
    }
  })])], 1), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "legend-group",
    class: {
      'zh1': !_vm.isEn, 'es1': _vm.isEs, 'de1': _vm.isDe, 'it1': _vm.isIt, 'po1': _vm.isPo, 'du1': _vm.isDu || _vm.isFr || _vm.isCz
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/Alert.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('alert')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/target.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('target')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": require("../assets/Hcp-icon/legend/hypo.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('hypo')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": require("../assets/Hcp-icon/legend/SG.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('sensorGlucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/calib.png")
    }
  }), _c('span', {
    class: {
      'zh4': !_vm.isEn
    }
  }, [_vm._v(_vm._s(_vm.$t('calib')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/transmitter.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('newSen')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh2': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/warm up.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('warm')))])])])], 1), _vm._v(" "), _c('el-card', {
    staticClass: "monitor-card2"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('InsulinPump')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('timeOfLaPump')) + " : "), _c('span', [_vm._v(" " + _vm._s(_vm.pumpTime))])])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('table', {
    staticClass: "status-table1 status-table2"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('pumpSN')) + ": "), _c('label', [_vm._v(_vm._s(_vm.pump.serial))])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('status')) + ":"), _c('label', [_vm._v(_vm._s(_vm.pump.state))])]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('ReserviorLife')) + ": "), _c('label', [_vm._v(_vm._s(_vm.pump.remainingTime))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('InsulinLeft')) + ": "), _c('label', [_vm._v(_vm._s(_vm.pump.remainingDose))])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('basal')) + ":"), _c('label', [_vm._v(_vm._s(_vm.pump.basalRate) + " ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('totalBasal')) + ":"), _c('label', [_vm._v(_vm._s(_vm.pump.basalSum))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('lastBolus')) + ":"), _c('label', [_vm._v(_vm._s(_vm.lastBolus))])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.$t('activeInsulin')) + ":"), _c('label', [_vm._v(_vm._s(_vm.pump.iob))])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('totalBolus')) + ":"), _c('label', [_vm._v(_vm._s(_vm.pump.bolusSum) + " ")])])])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "chart2"
    }
  })])], 1), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "legend-group card2-legend",
    class: {
      'zh3': !_vm.isEn, 'es3': _vm.isEs, 'de3': _vm.isDe, 'it2': _vm.isIt, 'po2': _vm.isPo, 'du2': _vm.isDu || _vm.isFr || _vm.isCz, 'sw2': _vm.isSw
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/Alert.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('alert')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/basal.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('basal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/temp basal.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('tampBasal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend "
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/normal bolus.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('normalBolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend "
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/extend bolus.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('extendBolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend "
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/auto suspend.png")
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('manualStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend sep-1"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/patch Deactivated.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('stop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend sep-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/new Patch.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('newPatch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend spe"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/Auto Suspend 2.png")
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('autoStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/automode/icon_histogram.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_basal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/automode/auto_bolus.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_bolus')))])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showConfirmDialog,
      "size": _vm.dialogSize,
      "id": "dialog-form2",
      "show-close": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showConfirmDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('privacy_policy_and_terms_of_use')))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-content"
  }, [_c('p', {
    attrs: {
      "id": "privacy_confirm_text"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('privacy_confirm_text'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('button', {
    staticClass: "deny",
    on: {
      "click": _vm.denyPrivacyConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t('privacy_confirm_disagree')))]), _vm._v(" "), _c('button', {
    staticClass: "agree",
    on: {
      "click": _vm.agreePrivacyConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t('privacy_confirm_accept')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f794c8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/monitor.vue
// module id = 1487
// module chunks = 7